module.exports = __webpack_public_path__ + "img/indicator0.41a0b895.png";